export default __webpack_public_path__ + "static/Ricky-1a2a3ad0f50aa103bbad3201fdeb2e5b.png";